/*
 * Проверка вложений перед отправкой.
 *
 * Запрещаем не «всё, кроме списка», а именно исполняемые файлы: в стройке
 * шлют что угодно — сметы, чертежи, архивы фотоотчётов, — и белый список
 * каждый раз оказывался бы короче реальной жизни. А вот программа в чате
 * компании не нужна никому и никогда.
 */

const BLOCKED_EXT = [
  'exe', 'msi', 'com', 'scr', 'pif', 'cpl', 'bat', 'cmd', 'vbs', 'vbe', 'js', 'jse',
  'wsf', 'wsh', 'ps1', 'psm1', 'sh', 'bash', 'zsh', 'jar', 'apk', 'app', 'dmg', 'pkg',
  'deb', 'rpm', 'msix', 'appx', 'gadget', 'lnk', 'reg', 'dll',
];

/** Больше этого один файл не примет сервер (видео и аудио — 64 МБ). */
const MAX_BYTES = 20 * 1024 * 1024;
const MAX_MEDIA_BYTES = 64 * 1024 * 1024;

export const extensionOf = (name: string): string => {
  const dot = name.lastIndexOf('.');
  return dot > 0 ? name.slice(dot + 1).toLowerCase() : '';
};

const limitFor = (mime: string): number =>
  mime.startsWith('video/') || mime.startsWith('audio/') ? MAX_MEDIA_BYTES : MAX_BYTES;

/** Причина отказа или пусто, если файл можно отправлять. */
export function fileProblem(file: { name: string; size: number; type: string }): string {
  const ext = extensionOf(file.name);
  if (BLOCKED_EXT.includes(ext)) {
    return `«${file.name}»: файлы .${ext} отправлять нельзя`;
  }
  const limit = limitFor(file.type || '');
  if (file.size > limit) {
    return `«${file.name}» больше ${Math.round(limit / 1024 / 1024)} МБ`;
  }
  if (!file.size) return `«${file.name}» пустой`;
  return '';
}

/** Делит выбранное на то, что уходит в сообщение, и первую причину отказа. */
export function screenFiles<T extends { name: string; size: number; type: string }>(
  files: T[],
): { accepted: T[]; error: string } {
  const accepted: T[] = [];
  let error = '';
  for (const f of files) {
    const problem = fileProblem(f);
    if (problem) error ||= problem;
    else accepted.push(f);
  }
  return { accepted, error };
}

/** Что предлагать в системном выборе файлов под каждым пунктом меню. */
export const ACCEPT_PHOTO = 'image/*,video/*';
export const ACCEPT_CAMERA = 'image/*';
